<div class="dashboard">
  <section class="dashboard__live-statistics">
    <sca-number-tile [scaApplicationsCount]="myRequisitionsCount"
      scaTitle="My Requisitions"
      scaCssClass="my-requisitions"
      (scaClick)="onMyRequisitionsClick()"
    [scaIsLoading]="isLoadingTopSectionTiles"></sca-number-tile>

    <sca-number-tile [scaApplicationsCount]="generalApplicationsCount"
      scaTitle="General Applications"
      scaCssClass="general-applications"
      (scaClick)="onGeneralApplicationsClick()"
    [scaIsLoading]="isLoadingTopSectionTiles"></sca-number-tile>

    <sca-number-tile [scaApplicationsCount]="unprocessedGeneralApplicationsCount"
      scaTitle="Unprocessed General Applications"
      scaCssClass="unprocessed-general-applications"
      (scaClick)="onUnprocessedGeneralApplicationsClick()"
    [scaIsLoading]="isLoadingTopSectionTiles"></sca-number-tile>

    <sca-number-tile [scaApplicationsCount]="liveRequisitionsCount"
      scaTitle="Live Postings"
      scaCssClass="live-postings"
      (scaClick)="onLiveRequisitionsClick()"
    [scaIsLoading]="isLoadingTopSectionTiles"></sca-number-tile>

    <sca-number-tile [scaApplicationsCount]="expiringRequisitionsCount"
      scaTitle="Expiring Postings"
      scaCssClass="expiring-postings"
      (scaClick)="onExpiringRequisitionsClick()"
    [scaIsLoading]="isLoadingTopSectionTiles"></sca-number-tile>

    <sca-number-tile [scaApplicationsCount]="expiredRequisitionsCount"
      scaTitle="Expired Postings"
      scaCssClass="expired-postings"
      (scaClick)="onExpiredRequisitionsClick()"
    [scaIsLoading]="isLoadingTopSectionTiles"></sca-number-tile>

    @if (isApprover) {
      <sca-number-tile [scaApplicationsCount]="pendingApprovalRequisitionsCount"
        scaTitle="Requires Approval"
        scaCssClass="pending-approval-requisitions"
        (scaClick)="onisPendingApprovalRequisitionsClick()"
        [scaIsLoading]="isLoadingTopSectionTiles"
      ></sca-number-tile>
    }

    @if (canManageSettings) {
      <sca-number-tile [scaApplicationsCount]="failedEmailsCount"
        scaTitle="Failed Emails"
        scaCssClass="failed-emails"
        (scaClick)="onFailedEmailsClick()"
        [scaIsLoading]="isLoadingTopSectionTiles"
      ></sca-number-tile>
    }
  </section>
</div>
